import(/* webpackMode: "eager" */ "/home/runner/_work/landfolk/landfolk/apps/design-system/app/page.tsx");
